import React from "react";
import { useMantineTheme } from "@mantine/core";
import type { MaterialSymbol } from "material-symbols";

export interface IconV3Props {
  icon: MaterialSymbol;
  size?: string | number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

// See developer integration guide for more info: https://developers.google.com/fonts/docs/material_symbols
// We are using a simple wrapper for importing & type-safety: https://www.npmjs.com/package/material-symbols
//
export const IconV3: React.FC<IconV3Props> = ({ icon, size = 24, color, className, style }) => {
  const theme = useMantineTheme();
  const finalColor = color || theme.black;
  return (
    <span
      className={`material-symbols-rounded ${className || ""}`}
      style={{
        fontSize: size,
        color: finalColor,
        display: "inline-block",
        lineHeight: 1,
        ...style,
      }}
    >
      {icon}
    </span>
  );
};
